export interface FAQItem {
  category: "all" | "aggregators" | "mot" | "crm" | "calendar" | "pricing";
  categoryLabel: string;
  question: string;
  answer: string;
}

export const FAQ_LIST: FAQItem[] = [
  // 1. AI Aggregators & Email Intake
  {
    category: "aggregators",
    categoryLabel: "AI Email & Aggregators",
    question: "How does the AI email booking parser work with BookMyGarage, ClickMechanic, and Fixter?",
    answer:
      "Garage Boost connects securely to your workshop Gmail via Google OAuth2. When a booking confirmation email arrives from BookMyGarage, ClickMechanic, Fixter, or WhoCanFixMyCar, our AI engine parses the email in under 3 seconds. It extracts the customer name, phone number, vehicle registration (VRM), service items, and chosen time slot, automatically generating a digital job card and booking the slot on your Google Calendar without manual data entry.",
  },
  {
    category: "aggregators",
    categoryLabel: "AI Email & Aggregators",
    question: "What happens if a customer cancels an aggregator booking?",
    answer:
      "Garage Boost continuously monitors incoming cancellation emails. When an aggregator cancellation notification is received, the system instantly frees up the reserved slot on your Google Calendar and updates your workshop schedule, ensuring no wasted bay time.",
  },
  {
    category: "aggregators",
    categoryLabel: "AI Email & Aggregators",
    question: "Do I need to install any software on my computer to connect Gmail?",
    answer:
      "No installation required! Garage Boost is 100% web-based. Connecting your Gmail account takes just two clicks with secure Google OAuth2 authentication. You can access your dashboard from any PC, iPad, tablet, or smartphone.",
  },

  // 2. DVSA MOT & Reminders
  {
    category: "mot",
    categoryLabel: "DVSA MOT & Reminders",
    question: "How does Garage Boost track DVSA MOT expiry dates?",
    answer:
      "Garage Boost integrates directly with official DVSA databases. Whenever a vehicle registration mark (VRM) is looked up or saved in your customer database, the system fetches statutory MOT expiry dates, road tax status, mileage history, and past MOT advisory records in real-time.",
  },
  {
    category: "mot",
    categoryLabel: "DVSA MOT & Reminders",
    question: "What is the 30-14-7 day MOT reminder sequence?",
    answer:
      "Our multi-touch reminder engine dispatches automated SMS and email notifications at tested intervals: 30 days before expiry (early awareness), 14 days before expiry (peak booking conversion window where 55%+ of motorists schedule their test), and 7 days before expiry (urgent final notice). Every message contains a direct 1-click booking link personalized to the driver's vehicle.",
  },
  {
    category: "mot",
    categoryLabel: "DVSA MOT & Reminders",
    question: "Can I send custom SMS messages with my garage's business name?",
    answer:
      "Yes! You can fully customize your SMS and email reminder templates. On Professional and Business plans, you can also set a custom UK SMS Sender ID so messages appear with your garage name (e.g. 'ApexMotors') instead of a random number.",
  },

  // 3. CRM & Advisory Quoting
  {
    category: "crm",
    categoryLabel: "CRM & Advisories",
    question: "How does Garage Boost turn MOT advisories into booked repair jobs?",
    answer:
      "When a vehicle passes its MOT with advisories (such as brake discs worn, tyres near legal limits, or suspension play), Garage Boost logs these items directly into your CRM. You can generate transparent fixed-price quotes in one click and dispatch them via SMS 45 to 60 days post-test, converting over 25% of advisories into high-margin repair work before the next MOT.",
  },
  {
    category: "crm",
    categoryLabel: "CRM & Advisories",
    question: "Can I import our existing customer database or spreadsheet?",
    answer:
      "Yes! You can easily import existing customer and vehicle CSV files. Our system will automatically cross-reference your VRM list with the DVSA database to update MOT expiry dates and mileage records instantly.",
  },
  {
    category: "crm",
    categoryLabel: "CRM & Advisories",
    question: "Is customer data GDPR compliant and stored in the UK?",
    answer:
      "Yes. Garage Boost adheres strictly to UK GDPR and data protection regulations. All data is encrypted in transit (TLS 1.3) and at rest (AES-256) within secure UK-based cloud infrastructure.",
  },

  // 4. Calendar & Bay Scheduling
  {
    category: "calendar",
    categoryLabel: "Google Calendar & Scheduling",
    question: "How does 2-way Google Calendar synchronization work?",
    answer:
      "Any job or MOT slot booked in Garage Boost immediately syncs to your Google Calendar, and any events added or adjusted on your Google Calendar update in Garage Boost. This gives your entire workshop team real-time visibility across ramps, technicians, and mobile vans.",
  },
  {
    category: "calendar",
    categoryLabel: "Google Calendar & Scheduling",
    question: "Can multiple mechanics or ramp bays be scheduled separately?",
    answer:
      "Yes! You can configure multiple bays, MOT test lanes, and technician schedules with custom working hours and capacity limits to prevent overbooking.",
  },

  // 5. Pricing & Setup
  {
    category: "pricing",
    categoryLabel: "Pricing & Plans",
    question: "How much does Garage Boost cost?",
    answer:
      "Pricing starts at £29/month for the Starter plan (up to 100 vehicles). The Professional plan is £59/month (up to 500 vehicles with AI email parsing and Google Calendar sync), and the Business plan is £99/month (unlimited users and vehicles). All plans include a 14-day free trial with no credit card required.",
  },
  {
    category: "pricing",
    categoryLabel: "Pricing & Plans",
    question: "Are there any long-term contracts or cancellation fees?",
    answer:
      "No! All Garage Boost subscriptions are month-to-month. You can upgrade, downgrade, or cancel your account at any time with a single click from your billing settings.",
  },
  {
    category: "pricing",
    categoryLabel: "Pricing & Plans",
    question: "What support is included with Garage Boost?",
    answer:
      "We provide UK telephone support (07380 448187), live email assistance (cs@bizzboost.uk), and free 1-on-1 remote onboarding sessions to help you set up your automated workflows.",
  },
];
